import React, { useState } from 'react';
import VerticalStepper from 'components/vertical-stepper/VerticalStepper';
import { ModalProps, StepperProps } from 'types/Modal';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import { DatasetCreateFormData, defaultCreateValues } from 'types/Forms';
import LastStep from 'components/vertical-stepper/LastStep';
import { useNavigate } from 'react-router-dom';
import { NDialog } from '@innersource-nn/novoui-react';

export default function CreateDatasetModal({ visible, onClose }: ModalProps) {
    const navigate = useNavigate();

    const [importing, setImporting] = useState(false);
    const [creationError, setCreationError] = useState('');

    const [newDataset, setNewDataset] = useState({
        datasetUri: '',
        label: '',
    });

    const [formData, setFormData] =
        useState<DatasetCreateFormData>(defaultCreateValues);
    const [activeStep, setActiveStep] = useState<number>(0);

    const handleClickSuccess = () => {
        navigate(`/dataset/${newDataset.datasetUri}`);
        if (onClose) onClose();
    };
    const steps: StepperProps[] = [
        {
            label: 'Creation method',
            content: (
                <FirstStep
                    importing={importing}
                    setImporting={setImporting}
                    setActiveStep={setActiveStep}
                    formData={formData}
                    setFormData={setFormData}
                />
            ),
        },
        {
            label: 'Name & Description',
            content: (
                <SecondStep
                    setActiveStep={setActiveStep}
                    formData={formData}
                    setFormData={setFormData}
                />
            ),
        },
        {
            label: 'Technical specifications',
            content: (
                <ThirdStep
                    importing={importing}
                    setActiveStep={setActiveStep}
                    formData={formData}
                    setFormData={setFormData}
                    setNewDataset={setNewDataset}
                    setCreationError={setCreationError}
                />
            ),
        },
    ];

    return (
        visible &&
        onClose && (
            <NDialog
                isVisible={visible}
                closeDialog={onClose}
                backgroundClose
                headline={activeStep === 3 ? '' : 'Create new dataset'}
                size="medium"
                showDividers={false}
            >
                {activeStep === 3 ? (
                    creationError === '' ? (
                        <LastStep
                            title="Dataset created!"
                            description={
                                <>
                                    Your new dataset:{' '}
                                    <b className="font-bold">
                                        {newDataset.label}
                                    </b>{' '}
                                    has been successfully created
                                </>
                            }
                            handleCancel={onClose}
                            primaryButtonAction={handleClickSuccess}
                            primaryButtonText="Go to dataset"
                            secondaryButtonText="Close"
                            type="success"
                        />
                    ) : (
                        <LastStep
                            title="Dataset creation failed"
                            type="error"
                            description={
                                <p>
                                    We encountered an error while creating your
                                    dataset. {creationError}
                                </p>
                            }
                            handleCancel={onClose}
                            primaryButtonAction={() => setActiveStep(0)}
                            primaryButtonText="Retry creating dataset"
                            secondaryButtonText="Contact support"
                            secondaryButtonAction={() =>
                                window.open(
                                    process.env.REACT_APP_TEAMS_LINK || '',
                                    '_blank',
                                )
                            }
                        />
                    )
                ) : (
                    <VerticalStepper
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                    />
                )}
            </NDialog>
        )
    );
}
